import React from 'react';
import { AlertTriangle } from 'lucide-react';

const euro = (v) => (v == null ? '—' : `€ ${Number(v).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`);

const Riga = ({ segno, label, valore, forte, testid }) => (
  <div className={`flex justify-between gap-3 py-1 ${forte ? 'border-t border-slate-600 lg:border-gray-200 font-semibold text-white lg:text-gray-900' : 'text-slate-300 lg:text-gray-600'}`}>
    <span><span className="inline-block w-4 text-slate-500 lg:text-gray-400">{segno}</span>{label}</span>
    <span data-testid={testid}>{valore}</span>
  </div>
);

const Colonna = ({ id, titolo, c, nFatture, nNote }) => (
  <div className="text-xs" data-testid={`conto-${id}`}>
    <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400 lg:text-gray-500 mb-1">{titolo}</p>
    <Riga segno="" label={c.magazzino.inizio_da === 'fine mese precedente' ? 'Magazzino inizio (mese prima)' : 'Magazzino inizio'} valore={euro(c.magazzino.inizio)} testid={`conto-${id}-mag-inizio`} />
    <Riga segno="+" label={nFatture != null ? `Acquisti da fatture (${nFatture})` : 'Acquisti da fatture'} valore={euro(c.acquisti_lordi_nc)} testid={`conto-${id}-acquisti`} />
    <Riga segno="−" label={nNote ? `Note di credito (${nNote})` : 'Note di credito'} valore={euro(c.note_credito)} testid={`conto-${id}-note-credito`} />
    {id === 'food' && <Riga segno="+" label="Acquisti senza fattura" valore={euro(c.extra)} testid="conto-food-extra" />}
    <Riga segno="−" label="Magazzino fine" valore={euro(c.magazzino.fine)} testid={`conto-${id}-mag-fine`} />
    <Riga segno="=" label="Consumo" valore={euro(c.consumo)} forte testid={`conto-${id}-consumo`} />
    <Riga segno="÷" label="Incassi senza IVA" valore={euro(c.incassi_netti)} testid={`conto-${id}-incassi-netti`} />
    <Riga segno="=" label={`${titolo} cost`} valore={c.percentuale != null ? `${c.percentuale}%` : 'N/D'} forte testid={`conto-${id}-percentuale`} />
  </div>
);

export default function ContoFoodCost({ dati }) {
  const conto = dati?.conto;
  if (!conto) return null;
  return (
    <div className="rounded-xl p-4 border border-slate-700 lg:border-gray-200 bg-slate-800/30 lg:bg-white mt-3" data-testid="conto-food-cost">
      <h4 className="text-sm font-bold text-white lg:text-gray-900">Come è calcolato</h4>
      <p className="text-[11px] text-slate-400 lg:text-gray-500 mb-3">Tutto senza IVA: acquisti al netto, incassi divisi per 1,10 (IVA 10%). Righe non alimentari escluse.</p>
      <div className="grid gap-5 sm:grid-cols-2">
        <Colonna id="food" titolo="Food" c={conto.food} nFatture={dati.acquisti?.num_fatture} nNote={dati.acquisti?.num_note_credito} />
        <Colonna id="beverage" titolo="Beverage" c={conto.beverage} />
      </div>
      {conto.avvisi?.length > 0 && (
        <ul className="mt-3 space-y-1" data-testid="conto-avvisi">
          {conto.avvisi.map((a) => (
            <li key={a} className="flex gap-1.5 text-[11px] text-amber-400 lg:text-amber-700"><AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-px" />{a}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
